(function () {
  'use strict';

  function initSmHeader() {
    var header = document.querySelector('[data-sm-header]');
    if (!header || header.dataset.smHeaderInit) return;
    header.dataset.smHeaderInit = 'true';

    var overlay = document.querySelector('[data-sm-header-overlay]');
    var openItem = null;

    function clearAlphaPanels(menu) {
      if (!menu) return;
      menu.querySelectorAll('.sm-alpha-menu__letter.is-active').forEach(function (btn) {
        btn.classList.remove('is-active');
      });
      menu.querySelectorAll('.sm-alpha-menu__featured-link.is-active').forEach(function (btn) {
        btn.classList.remove('is-active');
      });
      menu.querySelectorAll('.sm-alpha-menu__panel--items.is-visible').forEach(function (panel) {
        panel.classList.remove('is-visible');
      });
    }

    function openAlphaPanel(menu, panelKey, trigger) {
      clearAlphaPanels(menu);
      if (trigger) trigger.classList.add('is-active');
      var panel = menu.querySelector('[data-sm-alpha-panel="' + panelKey + '"]');
      if (panel) panel.classList.add('is-visible');
    }

    function openDefaultAlphaPanel(menu) {
      if (!menu) return;
      var featuredBtn = menu.querySelector('[data-sm-alpha-featured]');
      if (menu.querySelector('[data-sm-alpha-panel="featured"]') && featuredBtn) {
        openAlphaPanel(menu, 'featured', featuredBtn);
      }
    }

    function resetNavPanelPosition(panel) {
      if (!panel) return;
      panel.style.left = '';
    }

    function positionNavDropdown(item) {
      if (!item) return;
      var panel = item.querySelector('.sm-alpha-menu, .sm-header__dropdown');
      if (!panel) return;

      resetNavPanelPosition(panel);

      requestAnimationFrame(function () {
        var padding = 24;
        var rect = panel.getBoundingClientRect();
        if (rect.right > window.innerWidth - padding) {
          panel.style.left = (window.innerWidth - padding - rect.right) + 'px';
        }
      });
    }

    function closeAll() {
      if (openItem) {
        openItem.classList.remove('is-open');
        openItem = null;
      }
      if (overlay) overlay.classList.remove('is-visible');
      header.querySelectorAll('.sm-alpha-menu, .sm-header__dropdown').forEach(function (panel) {
        if (panel.classList.contains('sm-alpha-menu')) clearAlphaPanels(panel);
        resetNavPanelPosition(panel);
      });
      document.querySelectorAll('#NavDrawer .sm-alpha-menu').forEach(clearAlphaPanels);
      document.dispatchEvent(new CustomEvent('sm-header:close-search'));
    }

    function openNavItem(item) {
      if (openItem === item) {
        closeAll();
        return;
      }
      document.dispatchEvent(new CustomEvent('sm-header:close-search'));
      if (openItem) {
        openItem.classList.remove('is-open');
        openItem = null;
      }
      header.querySelectorAll('.sm-alpha-menu').forEach(function (menu) {
        clearAlphaPanels(menu);
        resetNavPanelPosition(menu);
      });
      header.querySelectorAll('.sm-header__dropdown').forEach(resetNavPanelPosition);
      document.querySelectorAll('#NavDrawer .sm-alpha-menu').forEach(clearAlphaPanels);
      item.classList.add('is-open');
      openItem = item;
      if (overlay) overlay.classList.add('is-visible');
      openDefaultAlphaPanel(item.querySelector('.sm-alpha-menu'));
      if (item.classList.contains('sm-header__nav-item--alpha') || item.classList.contains('sm-header__nav-item--dropdown')) {
        positionNavDropdown(item);
      }
    }

    header.querySelectorAll('[data-sm-nav-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = toggle.closest('.sm-header__nav-item');
        if (item) openNavItem(item);
      });
    });

    header.querySelectorAll('.sm-header__nav-link:not([data-sm-nav-toggle])').forEach(function (link) {
      link.addEventListener('click', function () {
        closeAll();
      });
    });

    document.querySelectorAll('[data-sm-alpha-letter]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('is-empty')) return;

        var menu = btn.closest('.sm-alpha-menu');
        if (!menu) return;

        openAlphaPanel(menu, btn.dataset.smAlphaLetter, btn);
        var navItem = menu.closest('.sm-header__nav-item--alpha');
        if (navItem) positionNavDropdown(navItem);
      });
    });

    document.querySelectorAll('[data-sm-alpha-featured]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var menu = btn.closest('.sm-alpha-menu');
        if (!menu) return;

        openAlphaPanel(menu, 'featured', btn);
        var navItem = menu.closest('.sm-header__nav-item--alpha');
        if (navItem) positionNavDropdown(navItem);
      });
    });

    if (overlay) {
      overlay.addEventListener('click', closeAll);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    document.addEventListener('click', function (e) {
      if (header.contains(e.target)) return;
      if (e.target.closest('#NavDrawer')) return;
      closeAll();
    });

    document.addEventListener('sm-header:close-nav', function () {
      if (openItem) {
        openItem.classList.remove('is-open');
        openItem = null;
      }
      header.querySelectorAll('.sm-alpha-menu').forEach(clearAlphaPanels);
    });

    /* Mobile nav — parent link toggles submenu instead of navigating */
    var navDrawer = document.getElementById('NavDrawer');
    if (navDrawer && !navDrawer.dataset.smMobileNavInit) {
      navDrawer.dataset.smMobileNavInit = 'true';

      navDrawer.addEventListener('click', function (e) {
        var link = e.target.closest('.mobile-nav__has-sublist > .mobile-nav__link');
        if (!link) return;

        e.preventDefault();
        var hasSublist = link.closest('.mobile-nav__has-sublist');
        if (hasSublist) {
          hasSublist.classList.toggle('mobile-nav--expanded');
          var item = link.closest('.mobile-nav__item');
          var alphaMenu = item ? item.querySelector('.sm-alpha-menu') : null;
          if (hasSublist.classList.contains('mobile-nav--expanded')) {
            openDefaultAlphaPanel(alphaMenu);
          } else if (alphaMenu) {
            clearAlphaPanels(alphaMenu);
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmHeader);
  } else {
    initSmHeader();
  }

  document.addEventListener('shopify:section:load', initSmHeader);
})();
/* Timber cancels touchmove on #PageContainer to stop the page scrolling
   behind an open drawer. #NavDrawer is inside that container, so the
   drawer never gets the gesture either. Let drawer touches through. */
document.addEventListener('touchmove', function (e) {
  if (e.target.closest && e.target.closest('#NavDrawer')) {
    e.stopPropagation();
  }
}, true);